import { CoreTooltip } from '@featuring-corp/components';
import { IconChatOutline, IconFavoriteOutline } from '@featuring-corp/icons';
import { vars } from '@styles/vanilla-extract/theme.css';
import { disabledAnchor } from '@styles/vanilla-extract/utils';
import React from 'react';

import round from '@utils/round';

import EllipsisText from '@shared/ellipsis-text/EllipsisText';

import CoreImg from '@shared/CoreImg';

import {
	containerClass,
	imgContainerClass,
	imgContentClass,
	textClass,
	textContentClass,
} from './style.css';
import CustomLink from 'src/shared/custom-link/CustomLink';

export interface FeedContentItemProps {
	outLink?: string;
	imgSrc?: string;
	likeCount?: number;
	commentCount?: number;
	idx?: number;
	isLikeHidden?: boolean;
	isCommentHidden?: boolean;

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const FeedContentItem = ({
	idx = 0,
	isLoading,
	isError,
	lackOfPermission,
	...props
}: FeedContentItemProps) => {
	const available = !isLoading && !isError && !lackOfPermission;
	const outLink = !available ? '' : props.outLink;
	const imgSrc = isError
		? 'public/images/report/no-image.png'
		: lackOfPermission
		? `https://source.unsplash.com/random?${idx}`
		: props.imgSrc;

	const likeCount =
		isLoading || isError
			? '-'
			: lackOfPermission
			? '00'
			: props.likeCount?.toString()
			? round(props.likeCount, 'down')
			: '-';
	const commentCount =
		isLoading || isError
			? '-'
			: lackOfPermission
			? '00'
			: props.commentCount?.toString()
			? round(props.commentCount, 'down')
			: '-';

	return (
		<CustomLink
			href={outLink ?? ''}
			target={'_blank'}
			className={disabledAnchor}
			aria-disabled={!available}
		>
			<div className={containerClass}>
				<div className={imgContainerClass}>
					<div className={imgContentClass}>
						<CoreImg
							src={imgSrc ?? ''}
							alt="feed-content-image"
							is_loading={isLoading}
							object_fit="cover"
						/>
					</div>
				</div>

				<div className={textContentClass}>
					{/* 좋아요 수 비공개 */}
					{props.isLikeHidden && (
						<CoreTooltip
							disabled={!props.isLikeHidden}
							text={
								"계정 사용자가 게시물의 '좋아요' 수를 숨김 처리하여 숫자가 비공개 상태입니다."
							} //"계정 사용자가 게시물의 '좋아요' 수를 숨김 처리하여 숫자가 비공개 상태입니다."
							autoAdjust
						>
							<div className={textClass({ isPrivate: props.isLikeHidden })}>
								<IconFavoriteOutline fill={vars.semantic.color.text[1]} />

								{'비공개'}
							</div>
						</CoreTooltip>
					)}
					{/* 좋아요 수 공개 */}
					{!props.isLikeHidden && (
						<div className={textClass({ isPrivate: props.isLikeHidden })}>
							<IconFavoriteOutline fill={vars.semantic.color.text[1]} />

							<EllipsisText
								placement={undefined}
								zIndex={10000}
							>{`${likeCount} 개`}</EllipsisText>
						</div>
					)}

					{/* 댓글 비활성화 */}
					{props.isCommentHidden && (
						<CoreTooltip
							disabled={!props.isCommentHidden}
							text={
								'계정 사용자가 게시물의 댓글 기능을 비활성화하여 숫자가 비공개 상태입니다.'
							}
							autoAdjust
						>
							<div className={textClass({ isPrivate: props.isCommentHidden })}>
								<IconFavoriteOutline fill={vars.semantic.color.text[1]} />
								{'비활성화'}
							</div>
						</CoreTooltip>
					)}
					{/* 댓글 활성화 */}
					{!props.isCommentHidden && (
						<div className={textClass({ isPrivate: props.isCommentHidden })}>
							<IconChatOutline fill={vars.semantic.color.text[1]} />

							<EllipsisText placement={undefined} zIndex={10000}>
								{commentCount} 개
							</EllipsisText>
						</div>
					)}
				</div>
			</div>
		</CustomLink>
	);
};

export default FeedContentItem;
